/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Tap {
  /**
   * Returns the value you pass to the function. This is useful to "tapping" a pipe
   * and augmenting the entire adt being processed.
   *
   * @public
   * @function f1.tap
   * @param fn accept the entire value and process with a function
   * @example
   *
   * ```ts
   * tap((v) => v) === v
   * // or use in a pipe
   * pipe([tap((entireArray) => [...entireArray])], [1, 2, 3])
   * ```
   */
  <V>(fn: (v: V) => V, value: V): V;
  <V>(fn: (v: V) => V): (value: V) => V;
}

/**
 * @see Tap
 */
export default <V>(fn: (v: V) => V, value: V): V => {
  return fn(value);
};
